import { FIGCAPTION_STYLES as e, FIGURE_CENTERED_STYLES as t, getFigureRightStyles as n } from "../../constants/default-styles.mjs";
import { useTranslation as r } from "../../i18n.mjs";
import { ImageModeEnum as i, InsertParagraphEnum as a } from "./image-enum.mjs";
import o from "../../icons/turn-arrow-icon.mjs";
import { safeGetPos as s } from "../../utils/safe-get-pos.mjs";
import { ReactNodeViewRenderer as c, useReactNodeView as l } from "@tiptap/react";
import { useEffect as u, useState as d } from "react";
import { twMerge as f } from "tailwind-merge";
import { Button as p } from "@systemeio/components";
import { Fragment as m, jsx as h, jsxs as g } from "react/jsx-runtime";
import { Link01Icon as _, PhoneMaximizeIcon as v } from "@systemeio/icons";
import { Resizable as y } from "re-resizable";
//#region src/extensions/image-extension/custom-image.tsx
var b = ({ node: c, selected: b, editor: x, getPos: S, updateAttributes: C, maxWidth: w }) => {
	let { t: T } = r(), { src: E, alt: D, title: O, caption: k, width: A, height: j, containerWidth: M, href: N, imageMode: P, uploadingProps: F, isMobileFullWidth: I } = c.attrs, [L, R] = d(!1), [z, B] = d(!1), [V, H] = d(s(S) === 0), [U, W] = d(x.view.hasFocus()), G = U && b;
	u(() => {
		let e = Number(A), t = Number(j);
		if (w === void 0 || w <= 0 || !Number.isFinite(e) || !Number.isFinite(t) || t <= 0 || e <= w) return;
		let n = w / e;
		C({
			width: w,
			height: Math.round(t * n)
		});
	}, [
		j,
		w,
		C,
		A
	]), u(() => {
		let e = () => {
			H(s(S) === 0);
		};
		return x.on("update", e), () => {
			x.off("update", e);
		};
	}, [x, S]), u(() => {
		let e = () => {
			W(x.view.hasFocus());
		};
		return x.on("focus", e), x.on("blur", e), () => {
			x.off("focus", e), x.off("blur", e);
		};
	}, [x]);
	let K = x?.options.editable && !F, q = P === i.Inline, J = P === i.BlockCenter, Y = P === i.BlockRight, X = (e) => {
		e.preventDefault();
		let t = s(S);
		t !== void 0 && (x.commands.setNodeSelection(t), x.commands.focus());
	}, ee = (e, t, n) => {
		let r = n.style.width, i = n.parentElement?.offsetWidth;
		if (!i) return;
		let a = n.querySelector("img");
		if (!a) return;
		let o;
		if (r.includes("%")) o = r;
		else if (r.includes("px")) {
			let e = r.split("px")[0];
			o = Number(e) / i * 100 + "%";
		} else o = Number(a.naturalWidth) / i * 100 + "%";
		C({ containerWidth: o });
	}, Z = (e) => {
		if (!x) return;
		let t = s(S);
		if (t === void 0) return;
		let n = 0;
		switch (e) {
			case a.Before:
				n = t > 0 ? t - 1 : 0;
				break;
			case a.After: n = t + c.nodeSize;
		}
		x.chain().insertContentAt(n, { type: "paragraph" }).focus().run();
	}, { onDragStart: te } = l(), Q = (r) => {
		let i = f(G || L ? "bg-border-accent" : z ? "bg-system-warning-100" : "bg-transparent", "transition-base");
		return /* @__PURE__ */ g(y, {
			"data-node-view-wrapper": "",
			onDragStart: te,
			style: {
				...J && t,
				...Y && n(V)
			},
			as: q ? "span" : "figure",
			size: {
				width: M,
				height: "100%"
			},
			handleClasses: {
				top: i,
				bottom: i,
				left: i,
				right: i
			},
			handleStyles: {
				top: {
					height: 2,
					top: -2,
					width: "calc(100% + 2px)",
					left: -2
				},
				bottom: {
					height: 2,
					bottom: -2,
					width: "calc(100% + 2px)",
					right: -2
				},
				left: {
					width: 2,
					left: -2,
					height: "calc(100% + 2px)",
					bottom: -2
				},
				right: {
					width: 2,
					right: -2,
					height: "calc(100% + 2px)",
					top: -2
				}
			},
			enable: K ? void 0 : !1,
			onResize: ee,
			minWidth: 50,
			minHeight: 50,
			maxWidth: "100%",
			lockAspectRatio: !0,
			onResizeStart: () => {
				R(!0);
			},
			onResizeStop: () => {
				R(!1);
			},
			className: f(q ? "inline-flex" : "flex", "flex-col", N ? "cursor-pointer" : "cursor-default", Y && "justify-end", J && "justify-center"),
			children: [r, k && /* @__PURE__ */ h("figcaption", {
				style: e,
				children: k
			})]
		});
	}, $ = (e) => /* @__PURE__ */ h("img", {
		src: E,
		alt: D ?? "",
		title: O ?? "",
		width: A,
		height: j,
		style: {
			minWidth: "100%",
			maxWidth: "100%",
			aspectRatio: A && j ? `${A}/${j}` : void 0
		},
		...e
	});
	return F?.isUploading ? Q($({ className: "animate-pulse" })) : Q(((e) => N ? /* @__PURE__ */ h("a", {
		className: "flex h-full w-full",
		href: N,
		onClick: (e) => e.preventDefault(),
		children: e
	}) : e)((() => {
		let e = M.includes("%") ? Number(M.split("%")[0]).toFixed(2) : void 0;
		return /* @__PURE__ */ g(m, { children: [
			$({
				onMouseEnter: () => B(!0),
				onMouseLeave: () => B(!1),
				onClick: X,
				"data-drag-handle": ""
			}),
			K && G && !q && /* @__PURE__ */ g(m, { children: [/* @__PURE__ */ h(p, {
				variant: "secondary",
				"aria-label": T("image_insert_before"),
				onMouseDown: (e) => e.preventDefault(),
				className: f("absolute -top-2.5 left-[5%] z-1"),
				onClick: () => Z(a.Before),
				size: "icon-xs",
				children: /* @__PURE__ */ h(o, { className: "rotate-90" })
			}), /* @__PURE__ */ h(p, {
				variant: "secondary",
				"aria-label": T("image_insert_after"),
				onMouseDown: (e) => e.preventDefault(),
				className: f("absolute right-[5%] -bottom-2.5 z-1"),
				onClick: () => Z(a.After),
				size: "icon-xs",
				children: /* @__PURE__ */ h(o, { className: "rotate-90" })
			})] }),
			/* @__PURE__ */ g("div", {
				className: "absolute top-3 right-3 flex flex-col items-center justify-center gap-1.5",
				children: [N && /* @__PURE__ */ h(_, { className: "text-icon-on size-5 rounded-sm bg-black/30" }), I && /* @__PURE__ */ h(v, { className: "text-icon-on size-5 rounded-sm bg-black/30" })]
			}),
			L && e && /* @__PURE__ */ g("span", {
				className: "text-text-on absolute bottom-3 left-3 bg-black/70 px-1 text-[10px]",
				children: [e, "%"]
			})
		] });
	})()));
}, x = (e) => c((t) => /* @__PURE__ */ h(b, {
	...t,
	maxWidth: e
}));
//#endregion
export { b as CustomImage, x as createCustomImageNodeView };
